/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { Layout, Card, Table, Tag, Spin, Button } from "antd";

import { getAPI } from "../../utils/common";

import {
  SMART_PRICE,
  SMART_PRICE_GENERATION_HISTORY,
} from "../../constants/api";
import { ReloadOutlined } from "@ant-design/icons";

import dayjs from "dayjs";

function SmartPriceGenerationHistory() {
  const { Content } = Layout;

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  useLayoutEffect(() => {
    getHistory();
  }, []);

  const getHistory = (page = 1) => {
    setLoading(true);

    getAPI(
      SMART_PRICE_GENERATION_HISTORY + "?page=" + page,

      (res) => {
        if (res.status) {
          setData(res.data.data);

          setPagination({
            current: res.data.current_page,

            pageSize: res.data.per_page,

            total: res.data.total,
          });
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const columns = [
    {
      title: "Generation Date",

      dataIndex: "generation_date",

      render: (date) => (
        <Tag color="blue">{date ? dayjs(date).format("DD MMM YYYY") : "-"}</Tag>
      ),
    },

    {
      title: "Total Rooms",

      dataIndex: "total_rooms",
    },

    {
      title: "Increase",

      dataIndex: "increase_count",

      render: (v) => <Tag color="green">{v}</Tag>,
    },

    {
      title: "Decrease",

      dataIndex: "decrease_count",

      render: (v) => <Tag color="red">{v}</Tag>,
    },

    {
      title: "Maintain",

      dataIndex: "maintain_count",

      render: (v) => <Tag color="orange">{v}</Tag>,
    },

    {
      title: "Trigger",

      dataIndex: "trigger_type",

      render: (v) => <Tag>{v}</Tag>,
    },

    {
      title: "Status",

      dataIndex: "status",

      render: (v) => {
        if (v === "success") return <Tag color="green">Success</Tag>;

        return <Tag color="red">Failed</Tag>;
      },
    },

    {
      title: "Started",

      dataIndex: "started_at",

      render: (date) =>
        date ? dayjs(date).format("DD MMM YYYY hh:mm A") : "-",
    },

    {
      title: "Completed",

      dataIndex: "completed_at",

      render: (date) =>
        date ? dayjs(date).format("DD MMM YYYY hh:mm A") : "-",
    },

    {
      title: "Error",

      dataIndex: "error_message",

      render: (v) => v || "-",
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Smart Price Generation History"
          bordered={false}
          extra={
            <Button
              icon={<ReloadOutlined />}
              onClick={() => getHistory()}
              loading={loading}
            >
              Refresh
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={{
                ...pagination,

                onChange: (page) => {
                  getHistory(page);
                },
              }}
              scroll={{
                x: 1200,
              }}
            />
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default SmartPriceGenerationHistory;
